import React, { useState } from "react";
import Autosuggest from "react-autosuggest";
import { getAirportsDetails } from "app/services/charterService";

const AirportDestination = ({ index, setFieldValue }) => {
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // Fetch airport suggestions
  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();

    if (!inputValue) return [];

    try {
      const { data } = await getAirportsDetails(inputValue);

      if (!data || data.Error) return [];

      return data.map((detail) => ({
        id: detail.id,
        label: `${detail.cityName} ${detail.cityCode}`,
      }));
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  // When suggestion selected
  const onSuggestionSelected = (fieldName, suggestion) => {
    setValue(suggestion.label);
    setFieldValue(fieldName, suggestion.id);
  };

  // Value that goes into input
  const getSuggestionValue = (suggestion) => suggestion.label;

  // Render dropdown item
  const renderSuggestion = (suggestion) => <div>{suggestion.label}</div>;

  // Input change
  const onChange = (event, { newValue }) => {
    setValue(newValue);

    setFieldValue(`flightLegs.onward[${index}].airportDestinationId`, "");
  };

  // Fetch suggestions on typing
  const onSuggestionsFetchRequested = async ({ value }) => {
    const data = await getSuggestions(value);
    setSuggestions(data);
  };

  // Clear suggestions
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    placeholder: "Airport Destination",
    value,
    onChange,
    className: "form-control",
    id: `flightLegs.onward[${index}].airportDestinationId`,
    name: `flightLegs.onward[${index}].airportDestinationId`,
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
      onSuggestionSelected={(event, { suggestion }) =>
        onSuggestionSelected(
          `flightLegs.onward[${index}].airportDestinationId`,
          suggestion,
        )
      }
    />
  );
};

export default AirportDestination;
